import React, { useState, useEffect } from 'react'


function Workshop() {
  const [workshops, setWorkshops] = useState([])
  const [pageContent, setPageContent] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchContent = async () => {
      try {
        // Using correct slug 'workshops'
        const pageResponse = await fetch('/wp-json/wp/v2/pages?slug=workshops')
        const pageData = await pageResponse.json()
        console.log('Page data:', pageData)
        
        if (pageData.length > 0) {
          setPageContent(pageData[0].content.rendered)
        }

        // For custom post type 'workshops'
        const postsResponse = await fetch('/wp-json/wp/v2/workshop')
        const postsData = await postsResponse.json()
        console.log('Workshops data:', postsData)
        
        if (Array.isArray(postsData)) {
          const sortedWorkshops = postsData.map(post => ({
            id: post.id,
            title: post.title.rendered,
            content: post.content.rendered,
            year_ws: post.acf?.year_ws || '',
            external_link_ws: post.acf?.external_link_ws || '',
            slug: post.slug
          }))
          setWorkshops(sortedWorkshops)
        }
        
        setLoading(false)
      } catch (error) {
        console.error('Error fetching content:', error)
        setLoading(false)
      }
    }

    fetchContent()
  }, [])
  if (loading) return <div className="loading">Loading...</div>

  return (
    <main className="workshop-page">
        <h1 className="page-title">Workshops</h1>
      
      {/* Page content section */}
      <div 
        className="workshop-content"
        dangerouslySetInnerHTML={{ __html: pageContent }}
      />
      
      {/* Workshops list section */}
      <section className="workshops-section">
      <h2 className="section-title">REFERENZEN</h2>
        <div className="workshops-grid">
          {workshops.map(workshop => (
            <article key={workshop.id} className="press-post">
              <div className="title-date-wrapper">
                <div className="post-date">
                  {workshop.year_ws}
                </div>
                <div className="title-links-wrapper">
                  <h3>{workshop.title}</h3>
                               <div className="post-content">
                <div 
                  className="post-excerpt"
                  dangerouslySetInnerHTML={{ __html: workshop.content }}
                />
              </div>
                  <div className="post-links">
                    {workshop.external_link_ws && (
                      <a 
                        href={workshop.external_link_ws} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="external-link"
                      >
                        Link zur Website ↪
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  )
}

export default Workshop


